import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#27ae60",
	height: 9,
	viewBox: "0 0 12 9",
	width: 12,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m4.24911 6.43265-2.4325-2.4325-.828329.8225 3.260829 3.26084 6.99999-7-.8225-.822504z" })
});
export { SvgCheck as ReactComponent };
